import { Component, OnDestroy, signal } from '@angular/core';
import { LeadService } from '../../services/leads/lead.service';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { Lead } from '../../lead.model';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DialogService } from '../../services/dialog/dialog.service';
import { MediaQueryService } from '../../services/media-query/media-query.service';
import { Subscription, Unsubscribable } from 'rxjs';

@Component({
  selector: 'app-selected-leads-preview',
  imports: [
    MatCell,
    MatTable,
    TranslatePipe,
    MatColumnDef,
    MatHeaderCell,
    MatCellDef,
    MatHeaderCellDef,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './selected-leads-preview.component.html',
  styleUrl: './selected-leads-preview.component.scss',
})
export class SelectedLeadsPreviewComponent implements OnDestroy {
  tableDataSource: MatTableDataSource<Lead> = new MatTableDataSource<Lead>([]);
  columnsToDisplay = ['name', 'postalCode', 'city', 'remove'];
  mediaQueryList: Unsubscribable;
  leadServiceSubscription: Subscription | undefined;

  showTable = signal<boolean>(false);

  constructor(
    protected leadService: LeadService,
    private dialogService: DialogService,
    mediaQueryService: MediaQueryService,
  ) {
    this.subscribeLeadService();
    this.mediaQueryList = this.adaptiveTableLayout(mediaQueryService);
  }

  subscribeLeadService(): void {
    this.leadServiceSubscription =
      this.leadService.selectedLeadsChanges$.subscribe(() => {
        this.tableDataSource.data = this.leadService.getSelectedLeads();
        this.showTable.set(this.tableDataSource.data.length > 0);
      });
  }

  removeSelected(toRemove: Lead) {
    this.leadService.removeSelectedLead(toRemove);
  }

  removeAll() {
    this.dialogService.openYesNoDialog(
      'components.selected-leads-preview.remove-all-dialog',
      'components.selected-leads-preview.remove-all-confirm',
      'components.selected-leads-preview.remove-all-cancel',
      () => this.leadService.removeAllSelectedLeads(),
      () => {
        return;
      },
    );
  }

  private adaptiveTableLayout(mediaQueryService: MediaQueryService) {
    return mediaQueryService.addListener(
      '(max-width: 700px)',
      (smallWidth: boolean) => {
        if (smallWidth) {
          // on very small devices, combine the postalCode and city into one column
          this.columnsToDisplay = ['name', 'postalCodeCity', 'remove'];
        } else {
          this.columnsToDisplay = ['name', 'postalCode', 'city', 'remove'];
        }
      },
    );
  }

  ngOnDestroy(): void {
    this.mediaQueryList.unsubscribe();
    this.leadServiceSubscription?.unsubscribe();
  }
}
